var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.81 9.73 4.137-7.343L31 12.363 20.874 29.752l-4.868-7.808-4.88 7.825L1 12.38l6.053-9.976 4.136 7.345 4.046-6.56.75-1.19.778 1.172L20.81 9.73zm-4.804-4.292 3.775 6.12-3.785 6.723-3.776-6.704 3.786-6.138zm-1.064 14.713L6.994 6.041 3.135 12.4l8.045 13.814 3.744-6.004-.008-.013.026-.046zm5.878 6.046 8.045-13.814-3.86-6.36L17.05 20.15l3.77 6.046z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWild);
export default __webpack_public_path__ + "static/media/WILD.66237c69e0df0bc584348e944e3b4c94.svg";
export { ForwardRef as ReactComponent };